import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import { convertSecondsToTime, parseDateSafe } from 'utils/timeHelper';
import { format } from 'date-fns';
import common from 'constants/common';
import PlayCallRecord from 'components/molecules/play-call-record';

import s from './style.module.scss';

import type { InboundCallLogs } from 'infrastructure/hooks/untrackedInboundCalls/types';
import type { TableProps } from 'antd';

export const useColumns = ({
  setItemToAssign,
  handleClear,
}: {
  setItemToAssign: (editingItem: InboundCallLogs) => void;
  handleClear: (callId: string) => void;
}): TableProps<InboundCallLogs>['columns'] => {
  const { t } = useTranslation();

  return [
    {
      title: t('labels.agent'),
      width: '10%',
      render: (_, record) => (
        <>
          <div>{record.agent}</div>
        </>
      ),
    },
    {
      title: t('labels.callId'),
      width: '10%',
      render: (_, record) => (
        <>
          <div>{record.callId}</div>
        </>
      ),
    },
    {
      title: t('labels.disconnectTime'),
      width: '10%',
      render: (_, record) => (
        <>
          <div>{datePresenter(record.disconnectTimestamp)}</div>
        </>
      ),
    },
    {
      title: t('labels.callDuration'),
      width: '20%',
      render: (_, record) => (
        <>
          <div>{convertSecondsToTime(record.duration)}</div>
        </>
      ),
    },
    {
      title: t('labels.sourcePhone'),
      width: '20%',
      render: (_, record) => (
        <>
          <div>{record.sourcePhone}</div>
        </>
      ),
    },
    {
      title: t('labels.callRecord'),
      width: '10%',
      render: (_, record) => (
        <PlayCallRecord callId={record.callId} module="untracked" />
      ),
    },
    {
      title: t('labels.action'),
      width: '1%',
      render: (_, record) => (
        <div className={s.actions}>
          <BaseButton
            label={t('labels.assign')}
            onClick={() => {
              setItemToAssign(record);
            }}
          />
          <BaseButton
            label={t('controls.clear')}
            onClick={() => {
              handleClear(record.callId);
            }}
          />
        </div>
      ),
    },
  ];
};

const datePresenter = (date: string | undefined) => {
  if (!date) return '';
  const parsedDate = parseDateSafe(date);
  if (!parsedDate) return '';

  return format(parsedDate, common.dateFormats.full);
};
